import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

/* Add local and extensions to dayjs */
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.locale('fr');

/**
 * Get date (format: DD.MM.YYYY)
 */
export const getDate = (date: string) => dayjs(date).format('DD.MM.YYYY');

/**
 * Get Full date (format: dddd, MMMM D, YYYY h:mm A)
 */
export const getFullDate = (date: string, hasSeconds = true) =>
  hasSeconds ? dayjs(date).format('LLLL') : dayjs(date).format('LLL');

/**
 * Get Time from now (Il y a 12 heures)
 * If you pass withoutSuffix true, you can get the value without the suffix (12 heures).
 */
export const getTimeFromNow = (date: string, withoutSuffix?: boolean) =>
  dayjs(date).fromNow(withoutSuffix).replace('il', 'Il');

/**
 * Get date from a timestamp as fromNow format
 *
 * @param timestamp - The date timestamp
 */
export const getDateFromTimestamp = (timestamp: number) =>
  dayjs(timestamp * 1000).fromNow();

/**
 * Get a fresh Day.js object with the current date and time
 */
export const getNow = () => dayjs();

/**
 * Get formatted date
 * @param date - The date
 * @param format - The format string
 */
export const getFormattedDate = (date: string, format: string) =>
  dayjs(date).format(format);

export const calculateDaysToBirthday = (dateString: string) => {
  const today = dayjs().startOf('day');
  const birthday = dayjs(dateString).startOf('day');

  const currentYear = today.year();
  const currentYearBirthday = dayjs(
    `${currentYear}-${birthday.format('MM-DD')}`
  );
  const nextYearBirthday = dayjs(
    `${currentYear + 1}-${birthday.format('MM-DD')}`
  );

  if (today.isAfter(currentYearBirthday)) {
    return nextYearBirthday.diff(today, 'day');
  } else {
    return currentYearBirthday.diff(today, 'day');
  }
};

export const getFormatDateStringFr = (oldFormatDate: String) => {
  let months = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'aout',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];

  let indexMonth = months.findIndex(
    month => month === oldFormatDate.split(' ')[1].toLowerCase()
  );
  let newFormatDate = `${indexMonth + 1}-${oldFormatDate.split(' ')[0]}-${
    oldFormatDate.split(' ')[2]
  }`;

  return newFormatDate;
};
